var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('date-range-editor',{model:{value:(_vm.rangeSelected),callback:function ($$v) {_vm.rangeSelected=$$v},expression:"rangeSelected"}})],1),_c('v-card-actions',[_c('v-btn',{on:{"click":_vm.changeManual1}},[_vm._v("Zmień 1")]),_c('v-btn',{on:{"click":_vm.changeManual2}},[_vm._v("Zmień 2")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }